/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { StorageGatewayDetails } from '../models/StorageGatewayDetails';

export class StorageGateway {
  /**
  * List of identifiers of the dlsg policies associated with the storage gateway.
  */
  'dlsgPolicyIds': Array<string>;
  /**
  * The region where the storage gateway is located.
  */
  'region': string;
  'storageGatewayDetails'?: StorageGatewayDetails;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dlsgPolicyIds",
      "baseName": "dlsgPolicyIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageGatewayDetails",
      "baseName": "storageGatewayDetails",
      "type": "StorageGatewayDetails",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StorageGateway.attributeTypeMap;
  }

  public constructor() {
  }
}

